import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { TokenStats } from "./components/TokenStats";
import { DelegationSteps } from "./components/DelegationSteps";
import { StatusPanel } from "./components/StatusPanel";
import { McpSection } from "./components/McpSection";
import { Roadmap } from "./components/Roadmap";
import { Footer } from "./components/Footer";
import { VideoSection } from "./components/VideoSection";
import { CircularGallery } from "./components/CircularGallery";
import { InkwellMouseBlob } from "./components/InkwellMouseBlob";
import { AiConnector } from "./components/AiConnector";

// Local video assets — loaded from public/videos/ for zero-latency playback.
const VIDEOS = {
  why:      "/videos/why.mp4",
  delegate: "/videos/delegate.mp4",
  mcp:      "/videos/mcp.mp4",
  pool:     "/videos/pool.mp4",
};

export default function App() {
  return (
    <main id="top" className="relative">
      <InkwellMouseBlob />

      <Hero />

      <Marquee
        items={[
          "mother nature's memecoin",
          "AI-only mint via MCP",
          "0.001 ETH per slot",
          "10 slots per address",
          "210,000 total slots",
          "v4 LP locked forever",
          "claim fees on chain",
        ]}
      />

      {/* SECTION 2 — "why we exist" with contained video on RIGHT, text on LEFT */}
      <VideoSection videoId={VIDEOS.why} mode="contained" align="left" parallax={280}>
        <div>
          <div className="eyebrow mb-4"><span className="dot" />why we exist</div>
          <h2 className="font-display text-5xl md:text-6xl tracking-tight leading-[0.95]">
            for the only{" "}
            <span className="font-serif italic text-aurora">home</span>{" "}
            we've got.
          </h2>
          <p className="mt-6 text-base text-bone-dim leading-relaxed">
            Memecoin minting has too much friction. Connect, fund gas, paste contract, sign, wait.
            Cycle dies before liquidity does. GAIA fixes it: sign once, then ask Claude.
          </p>
        </div>
      </VideoSection>

      <TokenStats />

      {/* SECTION 3 — moodboard gallery (no video background) */}
      <section className="relative overflow-hidden min-h-[120svh] py-24 md:py-32">
        <div className="absolute inset-0 pointer-events-none z-0" style={{
          background: "radial-gradient(60vmax 50vmax at 25% 25%, rgba(64,176,194,0.08), transparent 60%), radial-gradient(60vmax 50vmax at 80% 80%, rgba(61,220,151,0.05), transparent 60%)",
        }} />
        <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-10">
          <div className="max-w-3xl mb-8 mx-auto text-center">
            <div className="eyebrow mb-4 justify-center"><span className="dot" />moodboard</div>
            <h2 className="font-display text-5xl md:text-7xl tracking-tight leading-[0.95]">
              21,000 of us · <span className="font-serif italic text-aurora">one orbit</span>.
            </h2>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-bone-dim">
              click any sticker to zoom
            </p>
          </div>
          <CircularGallery />
        </div>
      </section>

      {/* SECTION 4 — AI mint intro with video on LEFT, text on RIGHT */}
      <VideoSection videoId={VIDEOS.delegate} mode="contained" align="right" parallax={280}>
        <div>
          <div className="eyebrow mb-4"><span className="dot" />step into AI mint</div>
          <div className="font-display text-5xl md:text-6xl tracking-tight leading-[0.95]">
            you don't mint here.{" "}
            <span className="font-serif italic text-aurora">Claude does.</span>
          </div>
          <p className="mt-6 text-base text-bone-dim leading-relaxed">
            Sign one EIP-7702 authorization to delegate your wallet. After that, Claude or Codex
            calls our MCP server and tokens land in your wallet automatically.
          </p>
        </div>
      </VideoSection>

      <DelegationSteps />
      <StatusPanel />

      {/* SECTION 6a — short MCP statement with video */}
      <VideoSection videoId={VIDEOS.mcp} mode="contained" align="left" parallax={260}>
        <div>
          <div className="eyebrow mb-4"><span className="dot" />universal AI mint</div>
          <h2 className="font-display text-5xl md:text-6xl tracking-tight leading-[0.95]">
            any agent. <span className="font-serif italic text-aurora">one MCP.</span>
          </h2>
          <p className="mt-6 text-base text-bone-dim leading-relaxed">
            Every AI-mint MCP we've seen is bolted to one vendor. GAIA's isn't. Any agent that
            speaks MCP — plus our portable <span className="font-mono text-bone">skills/mint.md</span> — can mint $GAIA.
          </p>
        </div>
      </VideoSection>

      {/* SECTION 6b — full MCP detail (snippet + agent grid) */}
      <McpSection />

      {/* SECTION 6c — AI agent connector setup (one-click like DogeShit) */}
      <AiConnector />

      {/* SECTION 7 — pool depth statement with video on the right */}
      <VideoSection videoId={VIDEOS.pool} mode="contained" align="left" parallax={300}>
        <div>
          <div className="eyebrow mb-4"><span className="dot" />the ring</div>
          <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[0.95]">
            every fee deepens the{" "}
            <span className="font-serif italic text-aurora">pool</span>.
          </h2>
          <p className="mt-6 max-w-xl text-base text-bone-dim leading-relaxed">
            All mint fees route to a Uniswap v4 LP that the contract itself
            owns. Liquidity only goes one way: in.
          </p>
        </div>
      </VideoSection>

      <Roadmap />
      <Footer />
    </main>
  );
}
